import $ from '../$';
import merge from '../functions/merge';
$.merge = merge;
